export default "__VITE_ASSET__DW7jvfsh__"